module.exports = __webpack_public_path__ + "img/soul-intro-small.d30a4da6.png";